<div class="row">
  <div class="col-xl-6 col-md-6 col-sm-12">
    <h3 class="text-white">Crear Una Noticia</h3>
    <div>
      <div class="form-group">
        <label for="exampleFormControlInput1">Titulo de la Noticia</label>
        <input type="text" class="form-control"
        [(ngModel)]="titulo" id="exampleFormControlInput1" placeholder="titulo de la noticia">
      </div>
      <div class="form-group mb-3">
        <label for="exampleFormControlTextarea1">Redacte la noticia</label>
        <textarea class="form-control"
         [(ngModel)]="mensaje" id="exampleFormControlTextarea1" rows="5"></textarea>
      </div>
      <button type="button" class="btn btn-info btn-block" (click)="create()" [disabled]="!titulo && !mensaje" >Crear</button>

    </div>

  </div>
  <div class="col-xl-6 col-md-6 col-sm-12">
    <h3 class="text-white">Noticias</h3>
    <div *ngFor="let item of data">
        <app-noticia [data]="item"></app-noticia>
    </div>

  </div>
</div>


<app-modal-loading [show]="modal_loading"></app-modal-loading>
